import { useLayoutEffect, useRef, useState } from "react";
import pxFromCm from "../util/pxFromCm";
import { EuropeHeaderProps } from "../editor/headerTypes";


interface EuropeHeaderPreviewProps {
  headerProps: EuropeHeaderProps;
  margin: number;
  reduceHeight: boolean;
}

export default function EuropeHeaderPreview(props: EuropeHeaderPreviewProps) {
  const { margin, headerProps, reduceHeight } = props;
  const headerTextContainerRef = useRef<null | HTMLDivElement>(null);
  const imgWidth = reduceHeight ? pxFromCm(5.0) : pxFromCm(5.52);
  const bottomMargin = reduceHeight ? pxFromCm(0.6) : pxFromCm(1);
  const [fontSize, setFontSize] = useState(100);

  useLayoutEffect(() => {
    if (headerTextContainerRef && headerTextContainerRef.current) {
      const textWidth = headerTextContainerRef.current.offsetWidth;
      const contentWidth = pxFromCm(21) - 2 * margin;
      const desiredTextWidth = contentWidth - imgWidth - (reduceHeight ? pxFromCm(1.0) : pxFromCm(1.25));
      const newFontSize = Math.min(450, Math.round(fontSize * desiredTextWidth / textWidth));
      setFontSize(newFontSize);
    }
  }, [headerProps, margin]); 

  const headers = [];
  if (headerProps) {
    if (headerProps.header1) {
      headers.push(headerProps.header1);
    }
    if (headerProps.header2) {
      headers.push(headerProps.header2);
    }
    if (headerProps.header3) {
      headers.push(headerProps.header3);
    }
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      margin: `${margin}px ${margin}px ${bottomMargin}px ${margin}px`,
    }}>
      <div style={{
        display: 'grid',
        flexGrow: 1,
        placeItems: 'center start',
      }}>
        <img src="/europe_map.png" style={{
          width: `${imgWidth}px`,
        }} alt="Europe map" />
      </div>
      {headerProps && <div 
        ref={headerTextContainerRef}
        style={{
          display: 'flex',
          flexDirection: 'column',
          color: `${headerProps.color}`,
          whiteSpace: 'nowrap',
          alignItems: 'end',
          fontFamily: '"Arial Black", "Helvetica", sans-serif',
          fontSize: `${fontSize}px`,
      }}>
        {headers.map((header, index) => {
          const actualFontSize = (headers.length == 3 && index > 0) ? 0.75 * fontSize : fontSize;
          return (
            <div key={index} style={{ fontSize: `${actualFontSize}px` }}>{header}</div>
          );
        })}
      </div>}
    </div>
  )
}